// @flow
import * as React from "react"
import { ContextMenuWrap } from "./styled"

type Props = {|
  children: React.Node,
  isOpen: boolean,
  close: Function,
  maxHeight?: string,
  minWidth?: number,
|}

const ContextMenu = ({
  children,
  isOpen,
  close,
  maxHeight,
  minWidth,
}: Props) => (
  <ContextMenuWrap
    isOpen={isOpen}
    maxHeight={maxHeight}
    minWidth={minWidth}
  >
    {isOpen && children}
  </ContextMenuWrap>
)

export default ContextMenu



// WEBPACK FOOTER //
// ./src/components/ContextMenu/index.js